import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import PDPPriceSectionUI from './PDPPriceSectionUI';
const PDPPriceSection = t0 => {
  const $ = _c(10);
  const {
    optionPrice: t1,
    priceObj,
    productId: t2,
    promotion,
    slug: t3,
    pdpIsModularBYOProduct: t4,
    variant
  } = t0;
  const optionPrice = t1 === undefined ? null : t1;
  const productId = t2 === undefined ? null : t2;
  const slug = t3 === undefined ? null : t3;
  const pdpIsModularBYOProduct = t4 === undefined ? false : t4;
  const {
    loading,
    priceDetails
  } = usePDPTieredPrice(priceObj, promotion, optionPrice, productId, slug);
  if (loading) {
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="PDPPriceSection__filler-loading" />;
      $[0] = t5;
    } else {
      t5 = $[0];
    }
    return t5;
  }
  const t5 = priceDetails?.priceWithOptionsPrice;
  const t6 = priceDetails?.salePriceWithOptionsPrice;
  const t7 = priceDetails?.leastTieredDiscountedPrice;
  const t8 = priceDetails?.maxTieredDiscountedPrice;
  const t9 = priceDetails?.hasDiscount;
  const t10 = priceDetails?.hasTieredDiscount;
  let t11;
  if ($[1] !== pdpIsModularBYOProduct || $[2] !== t10 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8 || $[7] !== t9 || $[8] !== variant) {
    t11 = <PDPPriceSectionUI price={t5} salePrice={t6} leastTieredDiscountedPrice={t7} maxTieredDiscountedPrice={t8} hasDiscount={t9} hasTieredDiscount={t10} pdpIsModularBYOProduct={pdpIsModularBYOProduct} variant={variant} />;
    $[1] = pdpIsModularBYOProduct;
    $[2] = t10;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
    $[8] = variant;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  return t11;
};
PDPPriceSection.propTypes = {
  optionPrice: PropTypes.number,
  priceObj: PropTypes.shape({
    data: PropTypes.shape({
      price: PropTypes.shape({
        price: PropTypes.number,
        optionPrice: PropTypes.number,
        promotion: PropTypes.shape({
          discount: PropTypes.number,
          discountType: PropTypes.string
        }),
        isClearance: PropTypes.bool
      })
    })
  }),
  productId: PropTypes.number,
  promotion: PropTypes.shape({
    discount: PropTypes.number,
    discountType: PropTypes.string
  }),
  slug: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  variant: PropTypes.oneOf(['PDPExtraOptionSelector', 'PDPUpSellFlyOut'])
};
export default PDPPriceSection;